<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="para-desc row">
        <div class="row">
          <div class="card shadow rounded border-0">
            <div class="card-body">
              <form class="login-form mt-4" [formGroup]="resetPasswordFg" (ngSubmit)="onSubmit()">
                <h5 class="mb-3 text-center">Reset Your Password</h5>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="text-muted">
                      Please fill your new password.
                    </p>
                  </div>
                  <div class="col-md-12 md-3">
                    <div class="form-floating mb-2">
                      <input type="email" formControlName="email" class="form-control" id="floatingInput"
                        placeholder="name@example.com">
                      <label for="floatingInput">Email address</label>
                    </div>
                    <small class="text-danger" *ngIf="validating.email.invalid && validating.email.touched">
                      Email is required
                    </small>
                  </div>
                  <div class="col-md-12 md-3">
                    <div class="form-floating mb-2">
                      <input type="password" formControlName="password" class="form-control" id="floatingInput"
                        placeholder="password">
                      <label for="floatingInput">Password</label>
                    </div>
                    <small class="text-danger" *ngIf="validating.password.invalid && validating.password.touched">
                      Password is required
                    </small>
                  </div>
                  <div class="col-md-12 md-3">
                    <div class="form-floating mb-2">
                      <input type="password" formControlName="passwordConfirmation" class="form-control"
                        id="floatingInput" placeholder="Confirm Password">
                      <label for="floatingInput">Confirm Password</label>
                    </div>
                    <small class="text-danger"
                      *ngIf="validating.passwordConfirmation.invalid && validating.passwordConfirmation.touched">
                      Password is required
                    </small>
                  </div>
                  <div class="col-md-12">
                    <div class="d-grid">
                      <button type="submit" class="btn btn-primary" [disabled]="preloader">
                        <span *ngIf="preloader" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        Send
                      </button>
                    </div>
                  </div>
                  <div class="mx-auto mb-0 mt-3">
                    <p class="mb-0 mt-3"><small class="text-dark me-2">Remember your account ?</small> <a
                        href="javascript:void(0)" (click)="routeHelper.navigated('login')" class="fw-bold color-brand">
                        Sign In</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
